export default __webpack_public_path__ + "static/en-3-511510e83b2bd34f1cadac46bf0747a6.svg";